import { useEffect, useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { Collapse, List, ListItem, ListItemIcon } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import { selectedAdminMenuAtom } from './Sidebar';
import { titleAtom } from '@/templates/AdminTemplates';
import { Button, Icon, Text } from '@/components/common/MenuItem';

import type { MenuProps } from '@/components/common/MenuItem';

export default function AdminMenuItem({ item }: MenuProps) {
  const { text, icon, path, child } = item;

  const [selectedMenu, setSelectedMenu] = useAtom(selectedAdminMenuAtom);
  const setTitle = useSetAtom(titleAtom);
  const [isOpen, setIsOpen] = useState(selectedMenu.startsWith(path));
  const navigate = useNavigate();

  useEffect(() => {
    setIsOpen(selectedMenu.startsWith(path));
  }, [path, selectedMenu]);

  function onMenuItemClick(path: string, text: string) {
    setSelectedMenu(path);
    setTitle(text);
    navigate(path, { replace: false, state: { title: text } });
  }

  return (
    <>
      <ListItem disablePadding>
        <Button disableRipple onClick={() => setIsOpen(!isOpen)}>
          <Icon>{icon}</Icon>
          <Text>{text}</Text>
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </Button>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List disablePadding>
          {child.map(({ text, path }) => (
            <ListItem key={text} disablePadding>
              <Button selected={selectedMenu === path} onClick={() => onMenuItemClick(path, text)}>
                <ListItemIcon />
                <Text>{text}</Text>
              </Button>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
}
